// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2fv3k","errorLogs":"styles_errorLogs__38ZRa"};